import axios from 'axios';

import type { Workflow, WorkflowPayload, WorkflowResponse, WorkflowRule, WorkflowRulePayload } from './automation-workflow-types';

export const listWorkflows = async () => {
  const response = await axios.get<Workflow[]>('/automation/workflow');
  return response.data;
};

export const getWorkflow = async (id: number) => {
  const response = await axios.get<Workflow>(`/automation/workflow/${id}`);
  return response.data;
};

export const createWorkflow = async (workflow: WorkflowPayload) => {
  const response = await axios.post<WorkflowResponse>('/automation/workflow', workflow);
  return response.data;
};

export const updateWorkflow = async (id: number, workflow: WorkflowPayload) => {
  const response = await axios.put<WorkflowResponse>(`/automation/workflow/${id}`, workflow);
  return response.data;
};

export const publishWorkflow = async (id: number) => {
  const response = await axios.put<WorkflowResponse>(`/automation/workflow/publish/${id}`);
  return response.data;
};

export const deleteWorkflow = async (id: number) => {
  await axios.delete(`/automation/workflow/${id}`);
};

export const listWorkflowRules = async () => {
  const response = await axios.get<WorkflowRule[]>('/automation/workflow/rule');
  return response.data;
};

export const createWorkflowRule = async (rule: WorkflowRulePayload) => {
  const response = await axios.post<WorkflowRule>('/automation/workflow/rule', rule);
  return response.data;
};

export const updateWorkflowRule = async (id: number, rule: WorkflowRulePayload) => {
  const response = await axios.put<WorkflowRule>(`/automation/workflow/rule/${id}`, rule);
  return response.data;
};

export const deleteWorkflowRule = async (id: number) => {
  await axios.delete(`/automation/workflow/rule/${id}`);
};
